export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/icons/construction_icon-417db733f5523f72f50ef3ca34c7ff62.svg";